import React, { useMemo } from 'react';

import { TiptapRichTextEditor } from 'components/DesignSystems/New/TiptapRichTextEditor';
import type { SitrepSectionType } from 'components/DisasterGPT/hooks/useSitrepsV2';
import { normalizeReportsSectionContent } from 'components/Reports/utils/normalizeReportsSectionContent';

type ReadOnlyReportsSectionDisplayProps = {
  section: SitrepSectionType;
};

const ReadOnlyReportsSectionDisplay: React.FC<
  ReadOnlyReportsSectionDisplayProps
> = ({ section }) => {
  const latestVersion = useMemo(
    () => section.section_versions?.[0],
    [section.section_versions]
  );

  const sectionText = useMemo(
    () => latestVersion?.sitrep_section_text || '',
    [latestVersion?.sitrep_section_text]
  );

  const displayContent = useMemo(
    () => normalizeReportsSectionContent(sectionText),
    [sectionText]
  );

  return (
    <div className="reports-section">
      <div>
        {sectionText && (
          <TiptapRichTextEditor
            value={displayContent}
            readOnly
            showToolbar={false}
            minHeight="2rem"
            className="reports-section__html-content"
          />
        )}
      </div>
    </div>
  );
};

export default ReadOnlyReportsSectionDisplay;
